import React from "react";

const SquashMatchDetails = ({ matches, userNames, styles }) => {
  // Helper function to get player name
  const getPlayerName = (playerId) => {
    if (!playerId) return "Not Selected";
    if (playerId === "guest") return "Guest Player";
    return userNames[playerId] || `Player ${playerId}`;
  };

  return matches.map((match, matchIndex) => {
    const playerAName =
      getPlayerName(match.playerAId) || match.playerA || "Player A";
    const playerBName =
      getPlayerName(match.playerBId) || match.playerB || "Player B";

    return (
      <div
        key={matchIndex}
        style={{
          marginBottom: "clamp(15px, 4vw, 20px)",
          padding: "clamp(12px, 3vw, 15px)",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(16px, 3.5vw, 20px)",
          }}
        >
          🎾 Squash Match #{matchIndex + 1}
        </h4>

        <div
          style={{
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(13px, 2.5vw, 15px)",
          }}
        >
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>Players:</strong> {playerAName} vs {playerBName}
          </p>
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>Format:</strong> Best of {match.bestOf} games to{" "}
            {match.pointsToWin} points
          </p>
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>Court:</strong> {match.courtNumber || 1}
          </p>
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>Match Type:</strong> {match.matchType || "recreational"}
          </p>
        </div>

        <div style={{ marginBottom: "clamp(12px, 3vw, 15px)" }}>
          <h5
            style={{
              color: "#34495e",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(14px, 3vw, 16px)",
            }}
          >
            Match Result
          </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              backgroundColor: "#f8f9fa",
              padding: "clamp(8px, 2vw, 10px)",
              borderRadius: "5px",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div style={{ textAlign: "center", minWidth: "100px" }}>
              <div
                style={{
                  fontSize: "clamp(20px, 5vw, 24px)",
                  fontWeight: "bold",
                  color: "#3498db",
                }}
              >
                {match.playerAGames}
              </div>
              <div style={{ fontSize: "clamp(12px, 2.5vw, 14px)" }}>
                {playerAName}
              </div>
            </div>
            <div
              style={{
                textAlign: "center",
                fontSize: "clamp(16px, 4vw, 20px)",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
              }}
            >
              -
            </div>
            <div style={{ textAlign: "center", minWidth: "100px" }}>
              <div
                style={{
                  fontSize: "clamp(20px, 5vw, 24px)",
                  fontWeight: "bold",
                  color: "#e74c3c",
                }}
              >
                {match.playerBGames}
              </div>
              <div style={{ fontSize: "clamp(12px, 2.5vw, 14px)" }}>
                {playerBName}
              </div>
            </div>
          </div>
          {match.winner && (
            <p
              style={{
                textAlign: "center",
                marginTop: "clamp(8px, 2vw, 10px)",
                fontWeight: "bold",
                color: "#27ae60",
                fontSize: "clamp(13px, 2.5vw, 15px)",
              }}
            >
              Winner: {match.winner === "playerA" ? playerAName : playerBName}
            </p>
          )}
        </div>

        {match.games && match.games.length > 0 && (
          <div>
            <h5
              style={{
                color: "#34495e",
                marginBottom: "clamp(8px, 2vw, 10px)",
                fontSize: "clamp(14px, 3vw, 16px)",
              }}
            >
              Game by Game
            </h5>
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "clamp(12px, 2.5vw, 14px)",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#ecf0f1" }}>
                    <th
                      style={{
                        padding: "clamp(6px, 1.5vw, 8px)",
                        border: "1px solid #bdc3c7",
                      }}
                    >
                      Game
                    </th>
                    <th
                      style={{
                        padding: "clamp(6px, 1.5vw, 8px)",
                        border: "1px solid #bdc3c7",
                      }}
                    >
                      {playerAName}
                    </th>
                    <th
                      style={{
                        padding: "clamp(6px, 1.5vw, 8px)",
                        border: "1px solid #bdc3c7",
                      }}
                    >
                      {playerBName}
                    </th>
                    <th
                      style={{
                        padding: "clamp(6px, 1.5vw, 8px)",
                        border: "1px solid #bdc3c7",
                      }}
                    >
                      Winner
                    </th>
                    <th
                      style={{
                        padding: "clamp(6px, 1.5vw, 8px)",
                        border: "1px solid #bdc3c7",
                      }}
                    >
                      Duration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {match.games.map((game, gameIndex) => (
                    <tr key={gameIndex}>
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {game.gameNumber}
                      </td>
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {game.playerAPoints}
                      </td>
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {game.playerBPoints}
                      </td>
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {game.winner === "playerA"
                          ? playerAName
                          : game.winner === "playerB"
                          ? playerBName
                          : "In Progress"}
                      </td>
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {game.duration || 0} min
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  });
};

export default SquashMatchDetails;
